import { State } from '../State';
import ruleset, { Limit } from '../ads/ads.ruleset';
import { isDynamicTestInBucket } from '../getters/ab';
import ab from '../ruleset/ab';

/**
 * Return current limit settings
 */
export function getLimits(state: State): Limit {
  return ruleset.limits['capped'];
}

/**
 * Return the number of ads seen in the last 6 hours
 */
export function getRecentlySeenAds(state: State, now: number): number {
  const { interval } = getLimits(state);

  const recentlySeenAds = state.seenAdTimestamps.filter(
    (timestamp) => now - timestamp <= interval,
  );

  return recentlySeenAds.length;
}

/**
 * Check if the user do not exceed the limit of ads per day
 */
export function canConsumeAds(state: State, now: number): boolean {
  const { count } = getLimits(state);

  return getRecentlySeenAds(state, now) < count;
}
